import { StaffMasterInfoDto } from '@siza-staff-care/shared/data';

/**
 * Returns staff details in a standard format.
 * @param staffCode The staff code
 * @param names The remaining names (first and surname)
 * @returns
 */
export const formatStaffDetails = (staffCode: string, ...names: string[]) => {
	let result = staffCode;

	if (names.length > 0) {
		result += ':';
	}

	result = names.reduce((result, name) => {
		return result + ' ' + name;
	}, result);

	return result;
};

/**
 * Returns a space-separated string of the staff names (e.g. firstnane, surname).)
 * @param names The names
 * @returns
 */
export const formatStaffName = (...names: string[]) => {
	return names.reduce((result, name) => {
		if (result) {
			result += ' ';
		}
		result += name;
		return result;
	}, '');
};

export const formatStaffMasterInfoDisplay = (info: StaffMasterInfoDto) => {
	const items = [info.displayName];

	if (info.telephone) {
		items.push(`Phone: ${info.telephone}`);
	}

	if (info.mobile) {
		items.push(`Mobile: ${info.mobile}`);
	}

	if (info.emailAddress) {
		items.push(`Email: ${info.emailAddress}`);
	}

	return items.join(', ');
};
